// Public tag identifiers, copied from the existing Google Ads purchase action.
// An incomplete configuration disables the integration; never substitute a
// customer account ID or a conversion-action ID for the Google tag ID.
export const GOOGLE_ADS_CONFIG = {
  tagId: 'AW-11327111632',
  purchaseLabel: 'bAJdCIq1zfQYENCDmJkq',
  hosts: ['bukietowa.pl', 'www.bukietowa.pl'],
} as const;
